import API from './API.js'
import axios from 'axios'

export default class Notificationsactions extends API {
  constructor() {
    super('notificationsactions')
  }
  async getNotifications() {
       const response = await axios.get(`/getNotifications`)
      return response.data
     
  }
  //ReadNotifications
  async ReadNotifications(params) {
    const response = await axios.get(`/ReadNotifications`, { params })
   return response.data
  
}
async ReadOneNotification(params) {
  const response = await axios.get(`/ReadOneNotification`, { params })
 return response.data

}
async ToggleActivation(id,key) {
  try {
    let params={'key':key};
    const response = await axios.get(`/notificationsactions/${id}/toggle_activation`,{params});
    return response.data
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      return error.response.data;

    }
  }
}
}
